export const emailValidator = (str: string): boolean => {
  const r =
    /(m)?^(?:[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+\.?)+(?:(?!..)\.[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;

  return r.test(str);
};
